import React from 'react';
import BaseComponent from '../../baseClasses/BaseComponent';
import caret from '../../assets/images/caret-white.svg';
import ExpandableSection from '../../components/ExpandableSectionSettings';
import PropTypes from 'prop-types';

import './MobileFilter.scss';

export default class MobileFilter extends BaseComponent {  
  constructor(props) {
    MobileFilter.propTypes = {
      //An array containing objects for filtering. The objects should have a title, type, and options. 
        //Title displayed at Expandable Section -- i.e. "Project Statuses"
        //Type is used to determine which appliedFilters are being used. -- i.e. "statuses"
        //Options are an array of the filtering options for each type of filters -- i.e. "['not_started', 'in_progress', 'completed']"
      filterOptions: PropTypes.arrayOf(PropTypes.object),
      //An object containing key/value pairs group selected filtering options
        //{"statuses": ['in_progress', 'completed'], "project_managers": [3, 1]}
      appliedFilters: PropTypes.object,
      //Filter handlers
      applyFilters: PropTypes.func,
      closeFilter: PropTypes.func,
      handleClear: PropTypes.func,
    };
    super(props);

    this.state = {
      appliedFilters: { ...props.appliedFilters },
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.appliedFilters && this.props.appliedFilters != this.props.appliedFilters) {
      this.setState({ appliedFilters: { ...this.props.appliedFilters } });
    }
  }

  componentWillUnmount() {
    this.setState({ appliedFilters: { ...this.props.appliedFilters } });
  }

  handleFilterSelect = option => {
    const currentFilters = this.state.appliedFilters ? this.state.appliedFilters : [];
    let currentFilter = currentFilters[option.type];

    if (option.value == -1) {
      currentFilter = [];
    }
    else if (currentFilter && currentFilter.includes(option.value)){
      currentFilter = currentFilter.filter(filterTerm => {
        return filterTerm != option.value;
      });
    } 
    else {
      if (!currentFilter) currentFilter = [];
      currentFilter = currentFilter.concat(option.value);
    }

    currentFilters[option.type] = currentFilter;

    this.setState({ appliedFilters: currentFilters });
  }

  applyFilters = (filterArray) => {
    if(Array.isArray(filterArray)) {
      this.props.applyFilters(filterArray);
    } else {
      this.props.applyFilters(this.state.appliedFilters);
      let filters=this.state.appliedFilters.statuses;
      if(filters && filters.length>0){
        this.props.handleAppliedFilters(filters.toString());
      }
      
    }
    this.props.closeFilter();
  }

  clearFilters = () => {
    this.setState({ appliedFilters: [] });
    this.props.closeFilter();
    this.props.handleClear();
  }

  createFilterCards() {
    const { appliedFilters } = this.state;
    let { filterOptions } = this.props;

    return filterOptions && filterOptions.map((filterOption, index) => {
      const filterList = filterOption.options.map(option => {

        let isSelected;
        if (appliedFilters[option.type] && appliedFilters[option.type].includes(option.value)) {
          isSelected = true;
        }
        else if ((!appliedFilters[option.type] || !appliedFilters[option.type].length) && option.value == -1) {
          isSelected = true;
        }

        return (
          <li
            key={option.value}
            name={option.value}
            onClick={() => this.handleFilterSelect(option)}
            className={`mobile-filter__option ${isSelected ? 'filter-selected' : ''}`}
          >
            {option.name}
          </li>
        );
      });

      return (
        <ExpandableSection
          name={filterOption.title}
          initiallyExpanded={filterOption.initiallyExpanded}
          hasBreakLine={true}
          key={index}
        >
          {filterList}
        </ExpandableSection>
      );
    });
  }

  createFilterCardOffline(){
    const { appliedFilters } = this.state;
    let { offlineFilter } = this.props;

    return offlineFilter && offlineFilter.map((filterOption, index) => {
      const filterList = filterOption.options.map(option => {

        let isSelected;
        if (appliedFilters[option.type] && appliedFilters[option.type].includes(option.value)) {
          isSelected = true;
        }
        else if ((!appliedFilters[option.type] || !appliedFilters[option.type].length) && option.value == -1) {
          isSelected = true;
        }

        return (
          <li
            key={option.value}
            name={option.value}
            onClick={() => this.handleFilterSelect(option)}
            className={`mobile-filter__option ${isSelected ? 'filter-selected' : ''}`}
          >
            {option.name}
          </li>
        );
      });

      return (
        <ExpandableSection
          name={filterOption.title}
          initiallyExpanded={filterOption.initiallyExpanded}
          hasBreakLine={true}
          key={index}
        >
          {filterList}
        </ExpandableSection>
      );
    });
  }

  // createFilterCardOffline(){
  //   const { appliedFilters } = this.state;
  //   let { offlineFilter } = this.props;

  //   return offlineFilter && offlineFilter.map((filterOption, index) => {
  //     const filterList = filterOption.options.map(option => {

  //       let isSelected
  //       if (appliedFilters[option.type] && appliedFilters[option.type].includes(option.value)) {
  //         isSelected = true
  //       }
  //       else if ((!appliedFilters[option.type] || !appliedFilters[option.type].length) && option.value == -1) {
  //         isSelected = true
  //       }

  //       return (
  //         <li
  //           key={option.value}
  //           name={option.value}
  //           onClick={() => this.handleFilterSelect(option)}
  //           className={`mobile-filter__option ${isSelected ? 'filter-selected' : ''}`}
  //         >
  //           {option.name}
  //         </li>
  //       )
  //     })

  //     return (
  //       <ExpandableSection
  //         name={filterOption.title}
  //         initiallyExpanded={filterOption.initiallyExpanded}
  //         hasBreakLine={true}
  //         key={index}
  //       >
  //         {filterList}
  //       </ExpandableSection>
  //     )
  //   })
  // }

  render() {
    const filterCards = this.createFilterCards();
    // const filterCardOffline = this.createFilterCardOffline()
    return (
      <section className='mobile-filter'>
        <header className='mobile-filter__header'>
          <a className='mobile-filter__back' onClick={this.props.closeFilter}>
            <img alt='Close Filter' src={caret} />
          </a>
          <p className='mobile-filter__title'>Filter</p>
        </header>
        <div className='mobile-filter__body'>
          <ul className='mobile-filter__list'>
            {filterCards}
          </ul>
          {/* <ul className='mobile-filter__list'>
            {filterCardOffline}
          </ul> */}
          <div className='mobile-filter__buttons'>
            <button
              onClick={this.clearFilters}>
                CLEAR
            </button>
            <button
              onClick={this.applyFilters}>
                APPLY
            </button>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MobileFilter/index.js